import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-mark-step",
  "use": "check-mark-step-usage",
  "viewBox": "0 0 10 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 8\" id=\"check-mark-step\"><path fill-rule=\"evenodd\" d=\"M2.085 2.593l1.909 1.912L7.886.624l1.408 1.402-5.3 5.324L.678 3.987z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol